import React, { Component } from "react";
import paintBucketImage from "./../../assets/images/paintbucket.png";
import scene1Thumbnail from "./../../assets/images/colour-in/scenes/1.png";
import scene1Svg from "./../../assets/images/colour-in/scenes/1.svg";
import scene2Thumbnail from "./../../assets/images/colour-in/scenes/2.png";
import scene2Svg from "./../../assets/images/colour-in/scenes/2.svg";
import scene3Thumbnail from "./../../assets/images/colour-in/scenes/3.png";
import scene3Svg from "./../../assets/images/colour-in/scenes/3.svg";
import scene4Thumbnail from "./../../assets/images/colour-in/scenes/4.png";
import scene4Svg from "./../../assets/images/colour-in/scenes/4.svg";

export interface ColourSceneSelectProps
{
    onSceneClicked: (colourMeScene: ColourMeScene) => void;
}

interface ColourSceneSelectState 
{
}

export interface ColourMeScene 
{
    thumbnail: string;
    scene: string;
    sceneName: string;
}

export class ColourSceneSelect extends Component<ColourSceneSelectProps, ColourSceneSelectState>
{
    private scenes: Array<ColourMeScene> = [
        {
            thumbnail: scene1Thumbnail,
            scene: scene1Svg,
            sceneName: "Scene 1"
        },
        {
            thumbnail: scene4Thumbnail,
            scene: scene2Svg,
            sceneName: "Scene 2"
        },
        {
            thumbnail: scene2Thumbnail,
            scene: scene3Svg,
            sceneName: "Scene 3"
        },
        {
            thumbnail: scene3Thumbnail,
            scene: scene4Svg,
            sceneName: "Scene 4"
        }
    ];

    constructor(props: ColourSceneSelectProps)
    {
        super(props);

        this.state = {
        };
    }

    private onSceneClicked(scene: ColourMeScene): void 
    {
        this.props.onSceneClicked(scene);
    }

    private buildScenes(): Array<JSX.Element>
    {
        let scenes = [];

        this.scenes.map((scene =>
            scenes.push(
                <div key={scene.sceneName} className="page" onClick={this.onSceneClicked.bind(this, scene)} style={{
                    backgroundImage: `url(${scene.thumbnail})`
                }} title={scene.sceneName}>
                </div>
            )
        ));

        return scenes;
    }

    public render(): JSX.Element
    {
        return (
            <>
                <div className="paint-bucket">
                    <img src={paintBucketImage} alt="Spilled paint bucket" />
                </div>

                <div className="colour-me-screen colour-selection">
                    <div className="container">
                        <div className="colour-me-container">

                            <h1 className="lead-title text-uppercase text-center">
                                Painting
                            </h1>

                            <h2 className="sub-title text-center">
                                Choose a page to colour
                            </h2>

                            <div className="pages mt-3">
                                {this.buildScenes()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}